var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../../themes/styled";
import Box from "../../box/Box";
import Text from "../../text/Text";
import { FieldStates } from "./FieldContext";
export { default as FieldBorder } from "./FieldBorder";
var themeFieldColor = function (p) {
    return p.currentState && p.theme
        ? p.theme.component.formfield[p.currentState].helperTextColor
        : "gray";
};
var StyledText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    user-select: none;\n"], ["\n    color: ", ";\n    user-select: none;\n"])), themeFieldColor);
export function HelperText(_a) {
    var fieldState = _a.fieldState, children = _a.children, id = _a.id, rest = __rest(_a, ["fieldState", "children", "id"]);
    return (React.createElement(Box, __assign({}, rest),
        React.createElement(StyledText, { id: id, fontSize: 1, currentState: fieldState.currentState, role: fieldState.currentState === FieldStates.ERROR ? "alert" : undefined }, children)));
}
HelperText.defaultProps = {
    pl: 3,
    pt: 1,
};
var templateObject_1;
//# sourceMappingURL=index.js.map